import React, { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, type BoxProps } from '@atlaskit/primitives/box';

export type THeadProps = BoxProps<'thead'>;

/**
 * __THead__
 *
 * A primitive table head container. Applies the HTML native element with no styling.
 *
 * @primitive
 */
export const THead: React.ForwardRefExoticComponent<
	Omit<THeadProps, 'ref'> & React.RefAttributes<HTMLTableSectionElement>
> = forwardRef<HTMLTableSectionElement, THeadProps>(({ children, ...props }, ref) => {
	return (
		<Box as="thead" {...props} ref={ref}>
			{children}
		</Box>
	);
});
